import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Fleet from "@/components/Fleet";
import Destinations from "@/components/Destinations";
import WhyChooseUs from "@/components/WhyChooseUs";
import Reviews from "@/components/Reviews";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import { Reveal } from "@/lib/reveal";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#050505] text-zinc-100">
      <Header />
      <Hero />
      {/* Below-the-fold sections fade+rise as they scroll in. Hero stays
          instant to protect LCP. Motion respects prefers-reduced-motion. */}
      <Reveal><Services /></Reveal>
      <Reveal><Fleet /></Reveal>
      <Reveal><Destinations /></Reveal>
      <Reveal><WhyChooseUs /></Reveal>
      <Reveal><Reviews /></Reveal>
      <Reveal><Contact /></Reveal>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
